/**
 * Trader Layout Component
 * Main layout wrapper with sidebar, header, and content area
 * Responsive: Drawer sidebar on mobile/tablet
 */
import { useTraderTheme } from '../context/TraderThemeContext';
import { MobileNavProvider, useMobileNav } from '../context/MobileNavContext';
import TraderSidebar from './TraderSidebar';
import TraderHeader from './TraderHeader';
import {AccessApprovalNotice} from './AccessApprovalNotice';
import {TraderConnection} from '../../components/connection/TraderConnection';
import '../styles/mt5-terminal.css';

const TraderLayoutInner = ({ children }) => {
  const { isDark } = useTraderTheme();
  const { isMobile, isTablet } = useMobileNav();

  return (
    <div data-testid="trader-terminal-shell" data-theme={isDark ? 'dark' : 'light'} className={`mt5-shell h-screen flex overflow-hidden ${
      isDark ? 'bg-[#0a0e17]' : 'bg-gray-100'
    }`}>
      {/* Sidebar - hidden on mobile/tablet (shown as drawer) */}
      {!isMobile && !isTablet && <TraderSidebar />}
      
      {/* Mobile/Tablet sidebar drawer */}
      {(isMobile || isTablet) && <TraderSidebar />}

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Header */}
        <TraderHeader />
        <TraderConnection/>
        <AccessApprovalNotice/>

        {/* Page Content */}
        <main className="flex-1 overflow-hidden">
          {children}
        </main>
      </div>
    </div>
  );
};

const TraderLayout = ({ children }) => {
  return (
    <MobileNavProvider>
      <TraderLayoutInner>{children}</TraderLayoutInner>
    </MobileNavProvider>
  );
};

export default TraderLayout;
